import { render, staticRenderFns } from "./ForumChannelView.vue?vue&type=template&id=440919aa&scoped=true&"
import script from "./ForumChannelView.vue?vue&type=script&lang=js&"
export * from "./ForumChannelView.vue?vue&type=script&lang=js&"
import style0 from "./ForumChannelView.vue?vue&type=style&index=0&id=440919aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440919aa",
  null
  
)

export default component.exports